import {LOADING, NOT_LOADING} from "./types";

//Loading
export default (ctr) => ({type: (ctr? LOADING : NOT_LOADING)})
